import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import Key from "../../../util/Key";

const Select = ({ dataSelect, setDataSelect }) => {
    const [typeSelect, setTypeSelect] = useState("custom");
    const [customData, setCustomData] = useState("");
    const addDataSelect = () => {
        setDataSelect([...dataSelect, { customData }]);
        setCustomData("");
    };

    const deleteItem = (item) => {
        const newDataSelect = dataSelect.filter(
            (element) => element.customData !== item
        );
        setDataSelect(newDataSelect);
    };
    return (
        <Form.Group className="mb-3">
            <Form.Label>Data option</Form.Label>

            <Form.Select
                aria-label="Default select example"
                defaultValue="0"
                onChange={(e) => {
                    setTypeSelect(e.target.value);
                }}
            >
                <option disabled value={typeSelect}>
                    Select data type
                </option>
                <option value="custom">Custom</option>
            </Form.Select>
            {typeSelect == "custom" && (
                <Form.Group>
                    <Form.Label htmlFor="inputDataSelect">Data</Form.Label>
                    <div className="input-delete ">
                        {dataSelect.map((item) => {
                            return (
                                <div className="content" key={Key()}>
                                    <p className="data">{item.customData}</p>
                                    <p
                                        className="delete btn"
                                        onClick={() => {
                                            deleteItem(item.customData);
                                        }}
                                    >
                                        X
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                    <Form.Control
                        id="inputDataSelect"
                        value={customData}
                        onChange={(e) => {
                            setCustomData(e.target.value);
                        }}
                    />

                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => {
                            addDataSelect();
                        }}
                    >
                        Add
                    </Button>
                </Form.Group>
            )}
        </Form.Group>
    );
};

export default Select;
